import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TaskService } from 'src/app/_services/task/task.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectTaskService } from 'src/app/_services/project_task/project-task.service'
import { ProjectService } from 'src/app/_services/project/project.service';
import { ProjectStructureService } from 'src/app/_services/projectStructure/projectStructure.service';
import { TimesheetService } from 'src/app/_services/timesheet/timesheet.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-project-taskV2',
  templateUrl: './project-taskV2.component.html',
  styleUrls: ['./project-taskV2.component.scss']
})
export class ProjectTaskV2Component implements OnInit {

  tenantId: string;
  userDetails: any;
  currentUser: any;
  form: FormGroup;
  projectTaskGridForm;
  timesheetForm;
  rowData: any;   // row data and column definitions  
  rowSelection: any;
  selectedCheckboxData = [];
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  private api: GridApi; // gridApi and columnApi 
  private columnApi: ColumnApi;
  defaultColDef: any;
  sampleGridFrameworkComponents: any;
  projectDropdownList = [];
  projectTaskDropdownList: any = [];
  taskDropdownList: any = [];
  subProjectDropdownList: any = [];
  partList: any[] = [];
  taskList: any[] = [];
  activityId: any;
  projectTaskId: any;
  selectedProjectId: any;
  projectName: any;
  taskName: any;
  public taskData: any;
  deleteConfirmationMsg = 'Are you sure you want to delete';
  minStartDate: any;
  minEndDate: any;
  minTSStartDate: any;
  minTSEndDate: any;

  constructor(
    private taskService: TaskService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private router: Router,
    private storageService: LocalStorageService,
    private projecttaskService: ProjectTaskService,
    private projectService: ProjectService,
    private projectStructureService: ProjectStructureService,
    private timesheetService: TimesheetService,
    private datePipe: DatePipe,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.projectTaskGridForm = new FormGroup({
      id: new FormControl(''),
      projectV2TaskName: new FormControl('', [Validators.required]),
      projectV2Id: new FormControl('', [Validators.required]),
      projectV2Name: new FormControl(""),
      projectV2Code: new FormControl(""),
      partList: new FormControl("", [Validators.required]),
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
      taskOwnerId: new FormControl(''),
      taskOwnerName: new FormControl("", [Validators.required]),
      status: new FormControl("", [Validators.required]),
      description: new FormControl(''),
      estimatedHours: new FormControl('', [Validators.required]),
      plannedStartDate: new FormControl(''),
      plannedEndDate: new FormControl(''),
      plannedStatus: new FormControl(''),
      predecessorProjectV2TaskId: new FormControl(''),
      predecessorProjectV2TaskName: new FormControl(''),
      successorProjectV2TaskId: new FormControl(''),
      successorProjectV2taskName: new FormControl(''),
      completionPercentage: new FormControl(''),
    });

    this.timesheetForm = this.formBuilder.group({
      id: new FormControl(''),
      assignedTo: new FormControl(''),
      projectV2Id: new FormControl(''),
      subprojectV2Id: new FormControl(''),
      projectV2TaskId: new FormControl(''),
      description: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl(''),
      totalHours: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      efficiency: new FormControl(''),
      projectV2ManagerName: new FormControl(''),
      projectV2LeadName: new FormControl(''),
      partList: new FormControl(''),
      commodity: new FormControl(''),
      businessGroup: new FormControl(''),
      taskStartDate: new FormControl(''),
      taskEndDate: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.getprojectsList();
    this.getProjectTaskForCurrentUser();
    // this.getTask();
  }

  // getter for easy access to form fields
  get f() {
    return this.projectTaskGridForm.controls;
  }

  get t() {
    return this.timesheetForm.controls;
  }

  getProjectTaskForCurrentUser() {
    this.taskService.getProjectTaskForCurrentUserV2(this.userDetails.id).subscribe((response: any) => {
      this.rowData = response;
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: 'Task Name',
        field: 'projectV2TaskName',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Task Owner Name',
        field: 'taskOwnerName',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Project Name',
        field: 'projectV2Name',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'SubProject Name',
        field: 'subprojectV2Name',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Business Group',
        field: 'businessGroup',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Commodity',
        field: 'commodity',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Part List',
        field: 'partList',
        filter: true,
        editable: false,
        sortable: true,

      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'EndDate',
        field: 'endDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Estimated Time',
        field: 'estimatedHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: "% for Completion",
        valueGetter: function (params) {
          return params.data.completionPercentage + '%';
        },
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Status',
        field: 'status',
        cellStyle: (params) => {
          if (params.value === 'Open' || params.value === 'open') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Close' || params.value === 'close') {
            return { color: 'blue', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Action',
        cellRenderer: (params) => {
          const spanElement = document.createElement('div');
          spanElement.innerHTML = `<button type="button" class="btn btn-sm btn-primary">Punch</button> `;
          spanElement.addEventListener('click', ($event) => {
            $event.preventDefault();
            this.taskData = params.data;
            let element: HTMLElement = document.getElementById('confimationBtn');
            if (element) {
              element.click();
            }
          });
          return spanElement;
        }
      },
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  timesheetPage() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/timesheets/timesheetV2']);
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  getprojectsList() {
    this.projectDropdownList = [];
    this.projectService.getAllProjectV2ByUserId(this.userDetails.id).subscribe((response: any) => {
      for (let item of response) {
        this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
      }
    });
  }

  onProjectChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const selectedProject = this.projectDropdownList.find(p => p === value);
    let selectedProjectId = selectedProject.split(' . ')[0]
    this.getAllTasksById(selectedProjectId);
    this.getPartList(selectedProjectId);

    this.projectService.getProjectV2(selectedProjectId).subscribe((response: any) => {
      this.activityId = response.activityId;

      this.minStartDate = this.datePipe.transform(response.startDate, 'yyyy-MM-dd');
      this.minEndDate = this.datePipe.transform(response.endDate, 'yyyy-MM-dd');
      this.getTask();
    });
  }

  getTask() {
    this.taskList = [];
    this.projectStructureService.getTaskDropdownByActivity(this.activityId).subscribe((response: any) => {
      for (let item of response) {
        this.taskList.push(`${item.taskDropdownName}`);
      }
    });
  }

  getPartList(selectedProjectId) {
    this.partList = [];
    this.projecttaskService.getPartList(selectedProjectId).subscribe((response: any) => {
      if (response) {
        for (let item of response) {
          this.partList.push(`${item.partList}`);
        }
      }
    });
  }

  getAllTasksById(selectedProjectId) {
    this.taskDropdownList = []
    this.taskService.getAllProjectTaskByProjectIdV2(selectedProjectId).subscribe((response: any) => {
      for (let item of response) {
        this.taskDropdownList.push(`${item.id} . ${item.projectV2TaskName}`);
      }
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.projectTaskId = this.selectedCheckboxData[0].id;
    this.getPartList(this.selectedCheckboxData[0].projectV2Id);
    this.onProjectChange({ target: { value: this.selectedCheckboxData[0].projectV2Id + ' . ' + this.selectedCheckboxData[0].projectV2Name } } as any)
    this.getTask();
    this.projectTaskGridForm.patchValue(this.selectedCheckboxData[0]);
    this.projectTaskGridForm.value.projectV2Id = this.selectedCheckboxData[0].projectV2Id + " . " + this.selectedCheckboxData[0].projectV2Name;
    this.projectTaskGridForm.value.taskOwnerName = this.projectTaskGridForm.value.taskOwnerId + " . " + this.projectTaskGridForm.value.taskOwnerName;
    this.projectTaskGridForm.value.estimatedHours = this.projectTaskGridForm.value.estimatedHours;
    this.projectTaskGridForm.value.partList = this.projectTaskGridForm.value.partList;
    if (this.selectedCheckboxData[0].predecessorProjectV2TaskId != null) {
      this.projectTaskGridForm.value.predecessorProjectV2TaskName = this.selectedCheckboxData[0].predecessorProjectV2TaskId + " . " + this.selectedCheckboxData[0].predecessorProjectV2TaskName;
    }
    if (this.selectedCheckboxData[0].successorProjectV2TaskId != null) {
      this.projectTaskGridForm.value.successorProjectV2taskName = this.selectedCheckboxData[0].successorProjectV2TaskId + " . " + this.selectedCheckboxData[0].successorProjectV2taskName;
    }
    this.projectTaskGridForm.patchValue(this.projectTaskGridForm.value);
  }

  createOpenModal() {
    this.modeAction = 1;
    this.projectTaskGridForm.reset();
    this.projectTaskGridForm.patchValue({
      id: '',
      projectV2TaskName: '',
      projectV2Id: '',
      partList: '',
      startDate: '',
      endDate: '',
      taskOwnerName: this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName,
      status: '',
      description: '',
      estimatedHours: '',
      plannedStartDate: '',
      plannedEndDate: '',
      plannedStatus: '',
      predecessorProjectV2TaskName: '',
      successorProjectV2taskName: '',
      completionPercentage: '',
    })
  }

  createProjectTask() {
    let data = {
      projectV2TaskName: this.projectTaskGridForm.get('projectV2TaskName').value,
      projectV2Id: parseInt((this.projectTaskGridForm.get('projectV2Id').value).toString().substring(0, ((this.projectTaskGridForm.get('projectV2Id').value).toString().indexOf('.')))),
      partList: this.projectTaskGridForm.get('partList').value,
      description: this.projectTaskGridForm.get('description').value,
      startDate: this.projectTaskGridForm.get('startDate').value,
      endDate: this.projectTaskGridForm.get('endDate').value,
      taskOwnerId: parseInt((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(0, ((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.')))),
      estimatedHours: this.projectTaskGridForm.get('estimatedHours').value,
      status: this.projectTaskGridForm.get('status').value,
      predecessorProjectV2TaskId: this.projectTaskGridForm.get('predecessorProjectV2TaskName').value?.split(' . ')[0],
      successorProjectV2TaskId: this.projectTaskGridForm.get('successorProjectV2taskName').value?.split(' . ')[0],
      plannedStartDate: this.projectTaskGridForm.get('plannedStartDate').value,
      plannedEndDate: this.projectTaskGridForm.get('plannedEndDate').value,
      plannedStatus: this.projectTaskGridForm.get('plannedStatus').value,
      completionPercentage: this.projectTaskGridForm.get('completionPercentage')?.value,
    }
    this.taskService.createProjectTasksV2(data).subscribe((response: any) => {
      this.api.applyTransaction({ add: [response] });
      this.getProjectTaskForCurrentUser();
      $('#closeCreateModal').trigger("click");
    });
  }

  updateProjectTask() {
    let data = {
      projectV2TaskName: this.projectTaskGridForm.get('projectV2TaskName').value,
      projectV2Id: parseInt((this.projectTaskGridForm.get('projectV2Id').value).toString().substring(0, ((this.projectTaskGridForm.get('projectV2Id').value).toString().indexOf('.')))),
      partList: this.projectTaskGridForm.get('partList').value,
      description: this.projectTaskGridForm.get('description').value,
      startDate: this.projectTaskGridForm.get('startDate').value,
      endDate: this.projectTaskGridForm.get('endDate').value,
      taskOwnerId: parseInt((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(0, ((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.')))),
      estimatedHours: this.projectTaskGridForm.get('estimatedHours').value,
      status: this.projectTaskGridForm.get('status').value,
      predecessorProjectV2TaskId: this.projectTaskGridForm.get('predecessorProjectV2TaskName').value?.split(' . ')[0],
      successorProjectV2TaskId: this.projectTaskGridForm.get('successorProjectV2taskName').value?.split(' . ')[0],
      plannedStartDate: this.projectTaskGridForm.get('plannedStartDate').value,
      plannedEndDate: this.projectTaskGridForm.get('plannedEndDate').value,
      plannedStatus: this.projectTaskGridForm.get('plannedStatus').value,
      completionPercentage: this.projectTaskGridForm.get('completionPercentage')?.value,
    }
    this.taskService.updateProjectTasksV2(data, this.projectTaskId).subscribe(response => {
      this.api.applyTransaction({ add: [response] });
      this.getProjectTaskForCurrentUser();
      $('#closeCreateModal').trigger("click");
    });
  }

  createTSOpenModal() {
    this.modeAction = 1;
    this.timesheetForm.reset();
    this.fetchProjectDetails(this.taskData.projectV2Id);
    this.timesheetForm.patchValue({
      assignedTo: this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName,
      projectV2Id: this.taskData.projectV2Id + ' . ' + this.taskData.projectV2Name,
      subprojectV2Id: this.taskData.subprojectV2Id + ' . ' + this.taskData.subprojectV2Name,
      projectManagerName: this.taskData.projectManagerName,
      projectLeadName: this.taskData.projectLeadName,
      projectV2TaskId: this.taskData.id + ' . ' + this.taskData.projectV2TaskName,
      partList: this.taskData.partList,
      commodity: this.taskData.commodity,
      businessGroup: this.taskData.businessGroup,
      taskStartDate: this.taskData.startDate,
      taskEndDate: this.taskData.endDate,
      description: this.taskData.description,
      totalHours: '',
      startDate: '',
      endDate: '',
      efficiency: '',
      status: '',
    });
    if (this.taskData.subprojectV2Id) {
      this.timesheetForm.value.subprojectV2Id = this.taskData.subprojectV2Id + ' . ' + this.taskData.subprojectV2Name,
        this.timesheetForm.patchValue(this.timesheetForm.value);
    }
    else {
      this.timesheetForm.value.subprojectV2Id = '';
      this.timesheetForm.patchValue(this.timesheetForm.value);
    }

    if (this.taskData.estimatedHours >= 8) {
      this.timesheetForm.value.totalHours = 8;
      this.timesheetForm.patchValue(this.timesheetForm.value);
    }
    else {
      this.timesheetForm.value.totalHours = this.taskData.estimatedHours;
      this.timesheetForm.patchValue(this.timesheetForm.value);
    }
    this.minTSEndDate = this.datePipe.transform(this.taskData.endDate, 'yyyy-MM-dd');
    this.minTSStartDate = this.datePipe.transform(this.taskData.startDate, 'yyyy-MM-dd');
  }

  fetchProjectDetails(projectId) {
    this.projectService.getProjectV2(projectId).subscribe((response: any) => {
      if (response) {
        this.timesheetForm.value.projectV2ManagerName = response.projectManagerName;
        this.timesheetForm.value.projectV2LeadName = response.projectLeadName;
        this.timesheetForm.value.businessGroup = response.businessGroupName;
        this.timesheetForm.value.commodity = response.commodityName;
        this.timesheetForm.patchValue(this.timesheetForm.value);
      }
    });
  }

  onChangeEvent(event) {
    this.timesheetForm.value.endDate = this.timesheetForm.get('startDate').value;
    this.timesheetForm.patchValue(this.timesheetForm.value);
  }

  createTimesheet() {
    let details = {
      assignedTo: parseInt(this.timesheetForm.get('assignedTo').value.toString().split(" . ")[0]),
      projectV2Id: parseInt(this.timesheetForm.get('projectV2Id').value.toString().split(" . ")[0]),
      subprojectV2Id: parseInt(this.timesheetForm.get('subprojectV2Id').value?.toString().split(" . ")[0]),
      projectV2TaskId: parseInt(this.timesheetForm.get('projectV2TaskId').value.toString().split(" . ")[0]),
      description: this.timesheetForm.get('description').value,
      startDate: this.timesheetForm.get('startDate').value,
      endDate: this.timesheetForm.get('endDate').value,
      totalHours: this.timesheetForm.get('totalHours').value,
      status: this.timesheetForm.get('status').value,
    };
    if (this.timesheetForm.get('totalHours').value <= 16) {
      this.timesheetService.createTimesheetV2(details).subscribe((response: any) => {
        $('#closeModalTimeSheet').trigger('click');
      });
    }
    else {
      window.alert("Please check the total hours added, it should be less than 16Hrs");
    }
  }

}